import { z } from 'zod';

enum PromoType {
  MokaOrderPriceCuts = 2,
  FreeItem = 3,
  DiscountPerItem = 4,
  DiscountToCart = 5,
}

enum PromoSalesTypeCategory {
  All = 'all',
  Specific = 'specific',
}

const promoInformationSchema = z
  .object({
    promoType: z.number({
      required_error: '*Please select a promo type',
    }),
    name: z.string().min(1, { message: '*Promo Name is required' }),
    outletIds: z.array(z.coerce.number(), { errorMap: () => ({ message: '*Assign at least one outlet' }) }).nonempty(),
    salesTypeCategory: z.nativeEnum(PromoSalesTypeCategory).optional().nullable(),
    salesType: z.array(z.number()).optional(),
  })
  .superRefine(({ promoType, salesTypeCategory, salesType }, ctx) => {
    if (promoType !== PromoType.MokaOrderPriceCuts && salesTypeCategory === PromoSalesTypeCategory.Specific && !salesType) {
      ctx.addIssue({
        path: ['salesType'],
        code: 'custom',
        message: '*Assign at least one sales type',
      });
    }
  });

type PromoInformationType = z.infer<typeof promoInformationSchema>;

export type { PromoInformationType };

export { PromoType, PromoSalesTypeCategory, promoInformationSchema };
